<template>
  <div class="index">
    <div class="centered">
      <router-link :to="{ name: 'BrokerageHouseCreator' }" class="button centered">Добавить брокерскую палату</router-link>
    </div>
    <draggable class="columns is-multiline mt-10" v-model="brokerageHousesObject">
      <BrokerageHouseItem 
        v-for="house in brokerageHousesObject" 
        :key="house.id" 
        :house="house"
        class="column is-one-quarter"
      />
    </draggable>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import draggable from 'vuedraggable'
  import deepcopy from 'deepcopy'
  import BrokerageHouseItem from 'components/BrandHistory/BrokerageHouseItem'

  export default {
    name: 'BrokerageHouses',
    data () {
      return {
      }
    },
    computed: {
      ...mapState(['brokerageHouses']),
      brokerageHousesObject: {
        get () { return deepcopy(this.brokerageHouses) },
        set (value) {
          const valueCopy = deepcopy(value)
          for (let i = 0; i < valueCopy.length; i++) {
            valueCopy[i].order = i
          }
          this.updateBrokerageHousesOrder(valueCopy)
        }
      }
    },
    created () {
      this.getBrokerageHouses()
    },
    methods: {
      ...mapActions(['getBrokerageHouses', 'deleteBrokerageHouse', 'updateBrokerageHousesOrder'])
    },
    components: { BrokerageHouseItem, draggable }
  }
</script>

<style>
.button.centered {
  margin: 20px 0 10px;
}
.box {
  position: relative;
}
.box img {
  margin: 20px 0 5px;
  max-height: 150px;
}
.delete {
  position: absolute !important;
  top: 5px;
  right: 5px;
}
</style>



// WEBPACK FOOTER //
// BrokerageHouses.vue?1e5898e3